import React from 'react';

// Styles & Assets
import styles from './ButtonForm.module.css';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string;
}

const ButtonForm: React.FC<Props> = ({ className = '', children, ...rest }) => {
    return (
        <button
            {...rest}
            className={`${className} ${styles.buttonPollForm}`.trim()}
        >
            {children}
        </button>
    );
};

export default ButtonForm;